(function () {
  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers')
    .controller('ActiveWaentController', activeWaentController)

  activeWaentController.$inject = ['NotificationService', 'WaentService', 'FoundationApi']

  function activeWaentController (NotificationService, WaentService, FoundationApi) {
    const vm = this
    construct()

    function construct () {
      resetActiveWaent()
    }

    vm.getWaentSubChannels = function () {
      resetWaentSubChannels()
      if (vm.activeWaent.channel_id) {
        WaentService
          .getUserSubChannelsByChannelId({ channelId: vm.activeWaent.channel_id })
          .$promise
          .then(function (data) {
            if (data.length) {
              vm.waentSubChannels = data[0].subChannels || []
            }
          })
          .catch(function (err) {
            NotificationService.errorHandler(err, 'Não foi possível carregar as subcontas.')
          })
      }
    }

    vm.createActiveWaent = function (sectorId) {
      if (!vm.activeWaent.channel_id || !vm.activeWaent.phone_number || !vm.activeWaent.message || !vm.activeWaent.template) {
        NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!')
        return false
      }

      vm.activeWaent.sector_id = sectorId
      WaentService
        .createActiveWaent(vm.activeWaent)
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            NotificationService.successHandler(data, 'Mensagem enviada com sucesso!')
            resetActiveWaent()
            FoundationApi.publish('dlgActiveWaent', 'close')
          } else {
            NotificationService.warningHandler(null, data.message)
            vm.activeWaent.is_loading = false
          }
        }).catch(function (response) {
          if (response && response.status === 401) {
            return NotificationService.warningHandler(null, 'Você não tem permissão para esta ação.')
          }
          NotificationService.errorHandler(null, response.data.message)
          vm.activeWaent.is_loading = false
        })
    }

    function resetWaentSubChannels () {
      vm.waentSubChannels = {}
      vm.activeWaent.subAccountId = undefined
    }

    function resetActiveWaent () {
      vm.activeWaent = {}
      resetWaentSubChannels()
    }
  }
// eslint-disable-next-line semi
})();
